import type { OmnisearchGridColDef } from "hooks/useOmnisearchDatagrid";

import { ExplainClassificationButton } from "components/waste/complianceEngine/ExplainClassificationButton";
import { WasteLinesUnifiedQuery } from "generated-graphql/graphql";

export type WasteLineUnifiedRow = NonNullable<
  WasteLinesUnifiedQuery["wasteLinesUnified"]
>["items"][number];

/**
 * Staff-only affordance column, appended last so it doesn't disturb the
 * customer-visible layout. Pulled out of ManifestLineItemsDataGrid.tsx so it
 * can be unit tested as a plain function without that file's fast-refresh
 * lint rule complaining about a non-component export living beside the
 * `ManifestLineItemsDataGrid` component.
 */
export const buildExplainClassificationColumn = (
  isStaff: boolean
): OmnisearchGridColDef<WasteLineUnifiedRow>[] =>
  isStaff
    ? [
        {
          field: "explainClassification",
          headerName: "",
          sortable: false,
          filterable: false,
          width: 56,
          align: "center",
          // Prevent row link wrapper — the button opens a dialog and has its
          // own click handler; nested inside the row's <a> it would fire the
          // link navigation on click and tear the dialog down immediately.
          linkable: false,
          renderCell: ({ row }: { row: WasteLineUnifiedRow }) => (
            <ExplainClassificationButton line={row} subtitle={row.lineItem ?? undefined} />
          ),
        },
      ]
    : [];
